enum Fishing {
  FISHING = '1',
  FISHING_NO_CATCH = '2',
  NO_FISHING = '3',
}

export default Fishing;
